import { useState } from 'react';

const PASSWORD = 'SLads2026';

export default function ProposalPage() {
  const [input, setInput] = useState('');
  const [unlocked, setUnlocked] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input === PASSWORD) {
      setUnlocked(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  if (unlocked) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#1e3a5f',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '2rem 1rem',
      }}>
        <div style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          padding: '2rem',
          maxWidth: '900px',
          width: '100%',
          textAlign: 'center',
          marginBottom: '1rem',
        }}>
          <img
            src="/images/logo.png"
            alt="S&L Contractors Logo"
            style={{ width: '80px', marginBottom: '1rem' }}
          />
          <h1 style={{
            fontSize: '1.5rem',
            color: '#1e3a5f',
            fontWeight: 700,
            margin: '0 0 0.5rem',
          }}>
            Digital Advertising Proposal
          </h1>
          <p style={{ color: '#6b7280', fontSize: '0.9rem', margin: '0 0 1rem' }}>
            Prepared by NextGear Web Services &bull; April 2026
          </p>
          <a
            href="/SL-Contractors-Ads-Proposal.pdf"
            download
            style={{
              display: 'inline-block',
              backgroundColor: '#0ea5e9',
              color: '#fff',
              padding: '0.75rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '1rem',
            }}
          >
            Download Proposal (PDF)
          </a>
        </div>
        <iframe
          src="/SL-Contractors-Ads-Proposal.pdf"
          title="Advertising Proposal"
          style={{
            width: '100%',
            maxWidth: '900px',
            height: '80vh',
            border: 'none',
            borderRadius: '8px',
          }}
        />
        <a
          href="https://nextgearwebservices.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.4rem',
            marginTop: '1.5rem',
            textDecoration: 'none',
          }}
        >
          <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.75rem', letterSpacing: '0.05em' }}>
            Powered by
          </span>
          <img
            src="/images/nextgear-logo.png"
            alt="NextGear Web Services"
            style={{ height: '18px', opacity: 0.6 }}
          />
        </a>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#1e3a5f',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '2.5rem',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <img
          src="/images/logo.png"
          alt="S&L Contractors Logo"
          style={{ width: '100px', marginBottom: '1.5rem' }}
        />
        <h1 style={{
          fontSize: '1.3rem',
          color: '#1e3a5f',
          fontWeight: 700,
          margin: '0 0 0.5rem',
        }}>
          Advertising Proposal
        </h1>
        <p style={{
          color: '#6b7280',
          fontSize: '0.85rem',
          margin: '0 0 1.5rem',
        }}>
          Enter the password to view this document.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={input}
            onChange={(e) => { setInput(e.target.value); setError(false); }}
            placeholder="Password"
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              fontSize: '1rem',
              border: `2px solid ${error ? '#dc2626' : '#d1d5db'}`,
              borderRadius: '8px',
              outline: 'none',
              boxSizing: 'border-box',
              marginBottom: '0.5rem',
            }}
            autoFocus
          />
          {error && (
            <p style={{ color: '#dc2626', fontSize: '0.8rem', margin: '0 0 0.5rem' }}>
              Incorrect password. Please try again.
            </p>
          )}
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: '#0ea5e9',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              marginTop: '0.5rem',
            }}
          >
            View Proposal
          </button>
        </form>
        <a
          href="https://nextgearwebservices.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.4rem',
            marginTop: '1.5rem',
            textDecoration: 'none',
          }}
        >
          <span style={{ color: '#9ca3af', fontSize: '0.7rem', letterSpacing: '0.05em' }}>
            Powered by
          </span>
          <img
            src="/images/nextgear-logo.png"
            alt="NextGear Web Services"
            style={{ height: '16px', opacity: 0.5 }}
          />
        </a>
      </div>
    </div>
  );
}
